// @code-guard: skip-file reason="design-system token registry; every entry is intentionally a hex literal"
//add all color constants here

export const colorConstants = {
    violet: '#44338A',
    /** Brand control focus outline — Figma Colors-Brand-Control-controlOutline */
    controlOutline: 'rgba(95, 73, 188, 0.1)',
    /** Ant Design default button shadow — controlTmpOutline */
    controlTmpOutline: 'rgba(0, 0, 0, 0.02)',
    darkGrey: '#807E86',
    grey: '#F7F5FF',
    orange: '#F1AD32',
    promoWarning: '#E17100',
    orangeAlt: '#E8A122',
    orangeAlt2: '#E6875E',
    orangeAlt3: '#ECA586',
    darkOrange: '#E06936',
    darkBlue: '#2F45DE',
    lightBlue: '#37C7BE',
    limeGreen: '#42A531',
    limeGreenAlt2: '#52C41A',
    limeAlt: '#87DED8',
    lightGreen: '#BBF1B0',
    lightGreenAlt: '#69D4E8',
    lightGreenAlt2: '#7ED957',
    darkGreen: '#759B25',
    darkGreenAlt: '#00798C',
    darkGreenAlt2: '#3394A3',
    red: '#CA3D3D',
    lightRed: '#FF9C9C',
    darkRed: '#B62548',
    greyAlt: '#D9D9D9',
    borderGrey: '#D7D6D9',
    lightBlack: '#433C4A',
    cream: '#FBE6BF',
    blackAlt: '#140B1D',
    purple: '#9E5897',
    darkBlueAlt: '#293BB8',
    pink: '#DD449F',
    pinkAlt: '#E469B2',
    pinkAlt2: '#EB8FC5',
    brown: '#A5582D',
    lightGrey: '#D8D8D8',
    fontGrey: '#4E4C55',
    borderGreyAlt: '#EAEAEC',
    cyan: '#43C9E2',
    blue: '#19669D',
    lightCyan: '#A0DBD8',
    lightCream: '#F2C77DB2',
    lightPink: '#EA87C2B2',
    lightOrange: '#DF8157B2',
    darkCyan: '#85B0B7B2',
    darkViolet: '#E6E0FF',
    limeGreenAlt: '#D2F4CB',
    lightRedAlt: '#FFCBCB',
    lightPurple: '#FAFAFC',
    white: '#FFFFFF',
    darkYellow: '#EDB44E',
    violetAlt: '#826FD0',
    greyAlt2: '#E6E6EA',
    greyAlt3: '#DBDFE9',
    greyAlt1: '#F4F3F5',
    greyAlt4: '#ACAAB0',
    fontGreyAlt: '#A49FA9',
    lightGreyAlt: '#f6f6f9',
    purpleFont: '#44328a',
    purpleFontSelected: '#5F49BC',
    purpleFontPressed: '#3B2C77',
    radioLabelHoverBg: '#F5F5F5',
    radioLabelPressedBg: '#FBFAFF',
    violetAlt1: '#BAB1E2',
    bestWeeksDarkRed1: '#D56464',
    bestWeeksDarkRed2: '#E59E9E',
    bestWeeksDarkRed3: '#F4D8D8',
    bestWeeksDarkGreen3: '#D9EDD6',
    bestWeeksDarkGreen2: '#A1D298',
    bestWeeksDarkGreen1: '#68B75A',
    lightBlueAlt: '#AFE9E5',
    greyAlt5: '#E0DEE2',
    greyAlt6: '#F0F0F0',
    greyAlt7: '#000000a6',
    greyAlt8: '#2b08491a',
    greyAlt9: '#FAFAFA',
    tableHoverCrossFill: '#FCFCFD',
    tableHeaderHoverFill: '#F1F2F4',
    tableHeaderHoverBg: 'rgba(0, 0, 0, 0.02)',
    tableColorSplit: 'rgba(0, 0, 0, 0.06)',
    tableRowAxisHoverFill: '#F7F7F8',
    greyAlt10: '#e4ebf780',
    greyAlt11: '#E4EBF7',
    greyAlt12: '#00000040',
    greyAlt13: '#f0f0f080',
    greyAlt14: '#00000073',
    /** Ant Design colorTextDescription — secondary / description text */
    colorTextDescription: 'rgba(0, 0, 0, 0.45)',
    /** Dropdown control item hover/filled background */
    dropdownControlItemBg: 'rgba(0, 0, 0, 0.04)',
    greyAlt15: '#8c8c8c',
    greyAlt16: '#0000000f',
    greyAlt17: '#bfbfbf',
    greyAlt18: '#0000008A',
    /** Modal secondary text — cancel button, radio labels, checked radio accent */
    greyAlt20: '#1F1F1F',
    /** PPA simulator filter — Show only toggle row labels (Edited / Impacted) */
    filterToggleLabel: '#1E1D1F',
    /** PPA simulator category search placeholder — Figma Neutral/7 */
    simulatorSearchPlaceholder: '#878787',
    // Solid equivalent of `greyAlt10` (#e4ebf780) rendered at 0.45 cell opacity over a white
    // background. Use this when the cell needs to be opaque (e.g. sticky/fixed columns) but
    // visually match the existing faded non-editable appearance.
    greyAlt19: '#F4F5F7',
    lightGreenAlt1: '#5FD3CB',
    greenALt1: '#95DE64',
    limeGreenAlt1: '#B7EB8F',
    darkGreenAlt3: '#228BD6',
    purpleAlt: '#B377AD',
    orangeAlt1: '#CC7442',
    violetAlt2: '#55A8E4',
    violetAlt3: '#7381E0',
    purpleAlt1: '#C699C2',
    yellow: '#F1C77A',
    yellowAlt: '#FFD666',
    blackAlt1: '#000000e0',
    /** rgba(0, 0, 0, 0.88) — Ant Design default button text */
    blackTransparent88: '#000000E0',
    /** rgba(0, 0, 0, 0.70) — secondary/body text on light backgrounds */
    blackTransparent70: '#000000B2',
    blueAlt: '#648BD8',
    blueAlt1: '#0958D9',
    blueAlt2: '#4096FF',
    blueAlt3: '#1677FF',
    blueAlt5: '#0591ffb3',
    blueAlt6: '#91CAFF',
    blueAlt4: '#58D1C9',
    redAlt: '#FF4D4F',
    redAlt1: '#FF7875',
    lightGreen1: '#F6FFED',
    lightYellow1: '#FFFBE6',
    lightBlue1: '#EBFCFF',
    lightBlue2: '#E6F4FF',
    lightOrangeAlt: '#FF9C6E',
    lightPurpleAlt: '#85A5FF',
    darkRed1: '#B63737',
    darkRed2: '#D56464',
    darkRed3: '#DF8B8B',
    lightRed1: '#EAB1B1',
    lightRed2: '#F4D8D8',
    darkGreen1: '#358427',
    darkGreen2: '#68B75A',
    darkGreen3: '#8EC983',
    lightGreen2: '#B3DBAD',
    lightGreen3: '#D9EDD6',
    seaGreen: '#00A656',
    bannerWarningBg: '#FFF4E8',
    bannerWarningBorder: '#FFD8A8',
    bannerWarningIcon: '#F1AD32',
    blackTitle: '#18181b',
    breadcrumbSlash: '#9F9FA9',
    tabBackground: '#F4F4F5',
    sliderLabelText: '#636A79',
    sliderRailLight: '#00000005',
    sliderHandleLine: '#D4D4DB',
    sliderTooltipBg: '#3F3F46',
    /** Figma colorTextSecondary — neutral secondary text */
    colorTextSecondary: '#3F3F46',
    sliderHandleOutlineShadow: '#5F49BC1A',
    axisLabelGrey: '#52525c',
    axisSelectedBg: '#fbfaff',
    axisInputErrorBorder: '#E08F8F',
    /** Inactive scenario tab strip background (Price Simulator V3) */
    scenarioTabInactiveBg: '#F0F2F5',
    /** Scenario lens tab — Figma primary/1 active background */
    lensTabActiveBg: '#F6F3FF',
    /** Scenario lens tab — Figma inactive background (primary/1 @ 60%) */
    lensTabInactiveBg: 'rgba(246, 243, 255, 0.6)',
    /** Toolbar control border — buttons, selects, search on scenario panel */
    toolbarBorderGrey: '#D9D9D9',
    /** Ant Design modal content elevation shadow */
    modalContentShadow: '0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',
    /** Figma boxShadowSecondary — elevated dropdown / popover panels */
    boxShadowSecondary:
        '0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',
    /** Ant Design default button drop shadow */
    buttonDefaultShadow: '0 2px 0 0 rgba(0, 0, 0, 0.02)',
    inactiveTabText: '#63748A',
    searchIcon: '#474747',
    headerColor: '#161227',
    /** Asper wordmark text and Ask Asper FAB background */
    asperNavy: '#271F49',
    packArchitectureBubbleDefault: '#00C800',
    tableHeaderBg: '#F6F5FA',
    /** Left sticky column shadow in Pack Architecture virtualized table */
    packArchitectureFrozenColumnShadow: 'rgba(15, 23, 42, 0.2)',
    growthUp: '#008236',
    growthDown: '#EC343E',
    black: '#000000',
    notificationError: '#FF4D4F',
    notificationSuccess: '#52C41A',
    notificationInfo: '#FAAD14',
    toolbarLabelGrey: '#71717B',
    /** Divider inside the scenario metadata tooltip card */
    tooltipDividerGrey: '#E4E4E7',
    /** Dark background for lens configuration tooltips */
    tooltipBg: '#060606',
    /** Whitespace Value Sales heatmap legend gradient — Figma min ramp */
    whitespaceHeatmapGradientStart: '#E9EDEA',
    /** Whitespace Value Sales heatmap legend gradient — Figma max ramp */
    whitespaceHeatmapGradientEnd: '#12E985',
    /** Default form control border — Scenario Lens inputs/dropdowns */
    inputBorderMuted: '#A8ADB8',
    /** Table header/cell divider — Scenario Lens table */
    tableCellBorder: '#D8DADF',
    /** Primary body text in Scenario Lens table cells */
    tableBodyText: '#27272A',
    /** Muted secondary metric text in Scenario Lens table */
    tableMutedText: '#B9BDC6',
    /** AI parent hierarchy hint text */
    tableHintText: '#9CA3AF',
    /** Scenario Lens table footer top border */
    tableFooterBorder: '#F1F1F3',
    /** Muted icon stroke in Scenario Lens table dropdowns */
    iconMuted: '#A1A1AA',
    /** Scenario Lens table header/icon primary text — Figma ColorTextPrimary */
    tableHeaderIcon: '#1B1D21',
    /** Scenario Lens sort/settings icon purple */
    tableSortIconPurple: '#5A2ED6',
    /** Scenario Lens KPI sort settings button background */
    tableSortIconBg: '#EFE9FE',
    /** Neutral control border (add-row / secondary buttons) */
    neutralBorder: '#D4D4D8',
    /** Neutral secondary button text */
    neutralText: '#4B5563',
    /** Hover wash for list options — rgba(0, 0, 0, 0.04) */
    blackTransparent04: 'rgba(0, 0, 0, 0.04)',
    /** Soft elevation shadow stop — rgba(0, 0, 0, 0.05) */
    blackTransparent05: 'rgba(0, 0, 0, 0.05)',
    /** Medium elevation shadow stop — rgba(0, 0, 0, 0.08) */
    blackTransparent08: 'rgba(0, 0, 0, 0.08)',
    /** Stronger elevation shadow stop — rgba(0, 0, 0, 0.12) */
    blackTransparent12: 'rgba(0, 0, 0, 0.12)',
    /** Global Filter V2 — Figma primary/6 (Apply fill, chips, links) */
    filterV2Primary: '#5A2ED6',
    /** Global Filter V2 — Figma primary/1 (chip + preset banner background) */
    filterV2PrimaryBg: '#F6F3FF',
    /** Global Filter V2 — Figma ColorBorder (dividers, outlined buttons) */
    filterV2Border: '#F1F2F4',
    /** Global Filter V2 — Figma ColorTextPrimary (panel title) */
    filterV2TextPrimary: '#1B1D21',
    /** Global Filter V2 — Figma 7 (attribute-type row labels) */
    filterV2TextSecondary: '#434751',
    /** Global Filter V2 — Figma selection-card close icon */
    filterV2IconMuted: '#A8ADB8',
    /** Navbar V2 — Figma ColorTextLabel (nav panel group + sub-group headers) */
    navV2TextMuted: '#636A79',
    /** RGM Landing — Figma primary/4 (headline gradient end) */
    landingAccent: '#C1B4FF',
    /** RGM Landing — Figma Colors/Base/Sapphire/1 (Executive Summary card border) */
    landingCardBorder: '#E8EAFA',
    /** RGM Landing — Figma 4 (#D8DADF) ("View more" button border) */
    landingBorderStrong: '#D8DADF',
    /** RGM Landing — Figma green/6 (positive delta text + arrow) */
    landingTrendUp: '#00A656',
    /** RGM Landing — Figma green/1 (positive delta chip background) */
    landingTrendUpBg: '#EBFFF6',
    /** RGM Landing — Figma Executive Summary "View more" link */
    landingLinkPrimary: '#7A56FA',
    /** RGM Landing — Figma yellow/1 (Studio "Strategic pricing" icon badge background) */
    landingYellowBg: '#FFEDDB',
    /** RGM Landing — Figma yellow/5 (tag-01 glyph fill) */
    landingYellowIcon: '#FF8205',
    /** RGM Landing — Figma peacock/1 (Studio "Portfolio architecture" icon badge background) */
    landingPeacockBg: '#D7F9F9',
    /** RGM Landing — Figma peacock/6 (package glyph fill) */
    landingPeacockIcon: '#169E9E',
    /** RGM Landing — Figma blue/1 (Studio "Trade promotion" + Exec Summary "Promo ROI" icon badge background) */
    landingBlueBg: '#E8EFFC',
    /** RGM Landing — Figma blue/6 (sale-02 glyph fill) */
    landingBlueIcon: '#5B91F4',
    /** RGM Landing — Figma blue/5 (Executive Summary card hover border, blue icon family) */
    landingBlueBorder: '#7CA7F6',
    /** RGM Landing — Figma red/5 (coins-hand glyph fill) */
    landingRedIcon: '#F23B63',
    /** RGM Landing — Figma red/3 (Executive Summary card hover border, red icon family) */
    landingRedBorder: '#F896AB',
    /** RGM Landing — Figma red/6 (layers glyph fill, search placeholder card) */
    landingRedIconStrong: '#E50F3E',
    /** RGM Landing — Figma yellow/0 (bar-chart icon badge background, search placeholder card) */
    landingOrangeSoftBg: '#FFF7F0',
    /** RGM Landing — Figma search shortcut badge (⌘K) background */
    landingSearchShortcutBg: '#F1F3F9',
    /** Login V2 — Figma right-panel gradient start */
    loginV2GradientStart: '#0C0721',
    /** Login V2 — Figma primary/7, right-panel gradient end */
    loginV2GradientEnd: '#4320A2',
    /** Login V2 — Figma carousel scrim, mid stop (black @ 82%) */
    loginV2ScrimMid: 'rgba(0, 0, 0, 0.82)',
    /** Login V2 — Figma carousel scrim, top stop (fully transparent black) */
    loginV2ScrimTop: 'rgba(0, 0, 0, 0)',
    /** Login V2 — Figma carousel pager dot */
    loginV2PagerDot: '#EDF2F7',
};
